/* Cavendis Lane, refonte Osprey : carrousels, onglets, galerie et choix de variante. */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initRails(root) {
    root.querySelectorAll('[data-clo-rail]').forEach(function (sec) {
      if (sec.dataset.cloReady) return;
      sec.dataset.cloReady = '1';
      var rail = sec.querySelector('.clo-rail');
      if (!rail) return;
      sec.querySelectorAll('[data-clo-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = rail.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
          rail.scrollBy({ left: step * Number(btn.dataset.cloDir), behavior: 'smooth' });
        });
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-clo-tabs]').forEach(function (sec) {
      if (sec.dataset.cloReady) return;
      sec.dataset.cloReady = '1';
      var tabs = sec.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on);
            var panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
          if (tab.dataset.link) {
            sec.querySelectorAll('[data-clo-tab-link]').forEach(function (link) {
              link.href = tab.dataset.link;
            });
          }
        });
      });
    });
  }

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || '£{{amount}}').replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function createPurchaseBar(sec, sticky) {
    var events = new AbortController(), signal = events.signal;
    var header = document.querySelector('header-component');
    var information = sec.querySelector('.clo-acc') || sec.querySelector('.clo-buy');
    var scene = sec.closest('.shopify-section') || sec;
    var leave = document.createElement('span'), enter = document.createElement('span');
    leave.className = enter.className = 'clp-purchase-sentinel';
    leave.dataset.clPurchaseBoundary = 'leave'; enter.dataset.clPurchaseBoundary = 'enter';
    leave.setAttribute('aria-hidden', 'true'); enter.setAttribute('aria-hidden', 'true');
    // Keep the threshold in normal flow while the product scene stays behind recommendations.
    var boundary = document.createElement('div'); boundary.className = 'clp-information-boundary';
    boundary.setAttribute('aria-hidden', 'true'); boundary.append(leave, enter); scene.after(boundary);
    document.body.append(sticky); document.body.classList.add('clp-has-purchase-bar');
    sticky.dataset.clPurchasePosition = 'top';
    var root = sec.parentElement;
    while (root && !(/auto|scroll/.test(getComputedStyle(root).overflowY) && root.scrollHeight > root.clientHeight)) root = root.parentElement;
    if (root === document.body || root === document.documentElement) root = null;
    var frame = 0, visible = false, passedEnter = false, passedLeave = false;
    var observer, headerKey = '', destroyed = false, dismissed = false;
    var close = sticky.querySelector('[data-cl-purchase-close]');
    close?.addEventListener('click', function (event) {
      event.preventDefault(); event.stopPropagation();
      dismissed = true; sticky.dataset.clPurchaseDismissed = 'true';
      visibility();
      if (sticky.contains(document.activeElement)) sec.querySelector('h1')?.focus({ preventScroll: true });
    }, { signal: signal });
    function visibility() {
      var next = !dismissed && (visible ? passedLeave : passedEnter);
      if (visible === next) return;
      visible = next; sticky.dataset.clPurchaseVisible = String(visible);
      sticky.setAttribute('aria-hidden', String(!visible)); sticky.inert = !visible;
    }
    function measure() {
      frame = 0;
      if (destroyed) return;
      if (!sec.isConnected) { destroy(); return; }
      if (!boundary.isConnected) return;
      // A responsive layout can release its initial nested scroll container.
      if (root && !(/auto|scroll/.test(getComputedStyle(root).overflowY) && root.scrollHeight > root.clientHeight)) {
        root = null; headerKey = '';
      }
      var headerHeight = header?.offsetHeight || 0;
      var top = headerHeight + 'px';
      if (sticky.style.getPropertyValue('--clp-floating-header') !== top) sticky.style.setProperty('--clp-floating-header', top);
      var threshold = (root ? root.getBoundingClientRect().top : 0) + headerHeight + 1;
      passedEnter = enter.getBoundingClientRect().bottom <= threshold;
      passedLeave = leave.getBoundingClientRect().bottom <= threshold;
      visibility();
      var lookahead = (root || document.scrollingElement).scrollHeight + innerHeight;
      var key = headerHeight + ':' + lookahead;
      if (key !== headerKey) {
        headerKey = key; observer?.disconnect();
        observer = new IntersectionObserver(function (entries) {
          if (destroyed) return;
          entries.forEach(function (entry) {
            var passed = entry.boundingClientRect.bottom <= (entry.rootBounds?.top ?? ((root ? root.getBoundingClientRect().top : 0) + (header?.offsetHeight || 0))) + 1;
            if (entry.target === enter) passedEnter = passed; else passedLeave = passed;
          });
          visibility();
        }, { root: root, rootMargin: '-' + headerHeight + 'px 0px ' + lookahead + 'px 0px', threshold: [0, 1] });
        observer.observe(leave); observer.observe(enter);
      }
    }
    function schedule() { if (!frame && !destroyed) frame = requestAnimationFrame(measure); }
    var resize = new ResizeObserver(schedule);
    [sec, scene, information, header].forEach(function (element) { if (element) resize.observe(element); });
    information?.addEventListener('toggle', schedule, { capture: true, signal: signal });
    window.addEventListener('resize', schedule, { passive: true, signal: signal });
    document.addEventListener('scroll', schedule, { capture: true, passive: true, signal: signal });
    document.addEventListener('shopify:section:unload', function (event) { if (event.target.contains(sec)) destroy(); }, { signal: signal });
    function destroy() {
      destroyed = true; events.abort(); resize.disconnect(); observer?.disconnect(); cancelAnimationFrame(frame);
      boundary.remove();
      sticky.remove(); document.body.classList.remove('clp-has-purchase-bar');
    }
    measure();
  }


  function createVariantSelection(data) {
    var order = data.current.map(function (_, index) { return index; });
    if (data.colourIndex > -1) order = [data.colourIndex].concat(order.filter(function (index) { return index !== data.colourIndex; }));
    function candidates(options, optionIndex, value) {
      var prefix = order.slice(0, order.indexOf(optionIndex));
      return data.variants.filter(function (variant) {
        return variant.options[optionIndex] === value && prefix.every(function (index) { return variant.options[index] === options[index]; });
      });
    }
    function select(options, changedIndex) {
      var result = options.slice();
      var boundary = order.indexOf(changedIndex);
      var prefix = boundary < 0 ? [] : order.slice(0, boundary + 1);
      var matches = data.variants.filter(function (variant) {
        return prefix.every(function (index) { return variant.options[index] === result[index]; });
      });
      if (!matches.length) return null;
      order.slice(boundary + 1).forEach(function (index) {
        var retained = matches.filter(function (variant) { return variant.options[index] === result[index]; });
        if (retained.length) matches = retained;
        else {
          var fallback = matches.find(function (variant) { return variant.available; }) || matches[0];
          result[index] = fallback.options[index];
          matches = matches.filter(function (variant) { return variant.options[index] === result[index]; });
        }
      });
      return matches[0].options.slice();
    }
    return { candidates: candidates, select: select };
  }

  function initProduct(root) {
    root.querySelectorAll('[data-clo-product]').forEach(function (sec) {
      if (sec.dataset.cloReady) return;
      var data, galleryData;
      try {
        data = JSON.parse(sec.querySelector('[data-clo-variants]').textContent);
        galleryData = JSON.parse(sec.querySelector('[data-clo-gallery]').textContent);
      } catch { return; }
      sec.dataset.cloReady = '1';
      var selection = createVariantSelection(data);
      var selected = data.current.slice();
      var requestedOptions = selected.slice();
      var form = sec.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var sticky = sec.querySelector('.clo-sticky');
      var atb = [...sec.querySelectorAll('.clo-atb')];
      var labels = [...sec.querySelectorAll('[data-clo-optlabel]')];
      var titles = [...sec.querySelectorAll('[data-clo-title]')];
      var prices = [...sec.querySelectorAll('[data-clo-price]')];
      var express = sec.querySelector('[data-cl-product-express]');
      var optionNotice = sec.querySelector('.cl-option-notice');
      var galleryRoot = sec.querySelector('.clo-gal');
      createPurchaseBar(sec, sticky);

      function findVariant(options = selected) {
        return data.variants.find(function (variant) {
          return variant.options.every(function (value, index) { return value === options[index]; });
        }) || null;
      }

      function purchaseState() {
        var variant = findVariant();
        var unavailable = !variant?.available;
        var disabled = unavailable || form.dataset.clBusy === 'true';
        var pending = sec.dataset.clGalleryBusy === 'true';
        if (idInput) {
          var value = variant ? String(variant.id) : '';
          if (idInput.value !== value) idInput.value = value;
          if (idInput.disabled !== unavailable) idInput.disabled = unavailable;
        }
        atb.forEach(function (button) {
          if (button.disabled !== disabled) button.disabled = disabled;
          button.setAttribute('aria-disabled', String(disabled || pending));
        });
        if (express) {
          // Keep Shopify's native component mounted; block stale checkout while a photo is pending.
          if (express.hidden !== unavailable) express.hidden = unavailable;
          express.inert = disabled || pending;
          express.setAttribute('aria-busy', String(pending));
        }
      }

      var gallery = window.CLProductExperience.createGallery(galleryRoot, data.title, galleryData, {
        onBusy: function (busy, pendingId) {
          sec.dataset.clGalleryBusy = String(Boolean(busy && String(pendingId || '') !== String(findVariant()?.id || '')));
          purchaseState();
        },
        onSelect: function (photo, options) {
          if (options) selected = options.slice();
          else if (photo?.targetVariantId) {
            var target = data.variants.find(function (variant) { return String(variant.id) === String(photo.targetVariantId); });
            if (target) selected = target.options.slice();
          } else if (photo && data.colourIndex > -1) selected[data.colourIndex] = photo.colour;
          requestedOptions = selected.slice();
          update(true);
        }
      });

      function update(fromGallery, options = selected) {
        if (!fromGallery) {
          requestedOptions = options.slice();
          var requested = findVariant(options);
          var result = requested ? window.CLProductExperience.resolve(galleryData, requested.id, data.colourIndex > -1 ? options[data.colourIndex] : '') : { images: [], reason: 'selection_required' };
          galleryRoot.dataset.clGalleryIssue = result.reason || '';
          galleryRoot.toggleAttribute('data-cl-image-missing', !result.images.length);
          gallery.select(result.images, gallery.images.length > 0, requested?.id, options.slice());
          return;
        }
        var variant = findVariant();
        var previousId = idInput?.value;
        sec.querySelectorAll('[data-clo-opt]').forEach(function (button) {
          var optionIndex = Number(button.dataset.cloOpt);
          var candidates = selection.candidates(selected, optionIndex, button.dataset.value);
          var exists = candidates.length > 0;
          var available = candidates.some(function (variant) { return variant.available; });
          button.hidden = !exists; button.disabled = !exists;
          button.dataset.combinationUnavailable = String(!exists);
          button.dataset.available = String(available);
          button.setAttribute('aria-pressed', String(button.dataset.value === selected[optionIndex]));
          var suffix = exists && !available ? data.soldOut : '';
          button.setAttribute('aria-label', button.dataset.value + (suffix ? ' · ' + suffix : ''));
        });
        labels.forEach(function (element) { element.textContent = selected[Number(element.dataset.cloOptlabel)] || ''; });
        prices.forEach(function (element) { element.textContent = variant ? money(variant.price, data.format) : ''; });
        sec.querySelectorAll('[data-clo-compare]').forEach(function (element) {
          element.textContent = variant?.compare > variant?.price ? money(variant.compare, data.format) : '';
        });
        var status = sec.querySelector('.clo-buy__st');
        if (status) {
          status.classList.toggle('is-out', !variant?.available);
          status.lastChild.textContent = !variant ? data.chooseOptions : variant.available ? data.inStock : data.soldOut;
        }
        var notice = sec.querySelector('.cl-oos-notice');
        if (notice) notice.hidden = !variant || variant.available;
        if (optionNotice) {
          optionNotice.hidden = Boolean(variant);
          optionNotice.textContent = variant ? '' : data.chooseOptions;
        }
        titles.forEach(function (element) {
          var description = element.querySelector('[data-cl-base-descriptor]');
          var colour = data.colourIndex > -1 ? selected[data.colourIndex] : '';
          if (description) description.textContent = [description.dataset.clBaseDescriptor, colour ? 'in ' + colour : ''].filter(Boolean).join(' ');
        });
        purchaseState();
        if (idInput && previousId !== idInput.value) idInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }

      sec.querySelectorAll('[data-clo-opt]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled || button.hidden || form.dataset.clBusy === 'true') return;
          var optionIndex = Number(button.dataset.cloOpt);
          var options = requestedOptions.slice(); options[optionIndex] = button.dataset.value;
          var resolved = selection.select(options, optionIndex);
          if (resolved) update(false, resolved);
        });
      });
      document.querySelectorAll('[data-clo-colourlink]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (data.colourIndex < 0) return;
          event.preventDefault(); var options = requestedOptions.slice(); options[data.colourIndex] = link.dataset.cloColourlink;
          var resolved = selection.select(options, data.colourIndex);
          if (resolved) update(false, resolved);
        });
      });
      update(false);
    });
  }

  function initSort(root) {
    root.querySelectorAll('[data-clo-sort]').forEach(function (sel) {
      if (sel.dataset.cloReady) return;
      sel.dataset.cloReady = '1';
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* Freeze the transparent-header offset so scrolling never moves the page. */
  var frozenWidth = 0;
  function freezeHeaderOffset(force) {
    if (!document.querySelector('.clo-hero')) return;
    if (!force && window.innerWidth === frozenWidth) return;
    var v = getComputedStyle(document.body).getPropertyValue('--header-group-height').trim();
    if (!v) return;
    frozenWidth = window.innerWidth;
    document.body.style.setProperty('--clo-hg', v);
  }
  window.addEventListener('load', function () { freezeHeaderOffset(true); });
  window.addEventListener('resize', function () { freezeHeaderOffset(false); });

  function init(root) {
    root = root || document;
    initRails(root); initTabs(root); initProduct(root); initSort(root);
  }
  onReady(function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

